import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LockIcon, StoreIcon, LayoutTemplateIcon, InboxIcon, LogOutIcon, ExternalLinkIcon } from 'lucide-react';
import { useContent } from '../ContentContext';
import { usePlatform } from '../contexts/PlatformContext';
import { PartnerWorkspace } from '../components/admin/PartnerWorkspace';
import { ContentManager } from '../components/admin/ContentManager';
import { RequestManager } from '../components/admin/RequestManager';
type Tab = 'verksamheter' | 'startsida' | 'forfragningar';
const TABS: {
  id: Tab;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}[] = [{
  id: 'verksamheter',
  label: 'Verksamheter',
  icon: StoreIcon
}, {
  id: 'startsida',
  label: 'Startsida',
  icon: LayoutTemplateIcon
}, {
  id: 'forfragningar',
  label: 'Förfrågningar',
  icon: InboxIcon
}];
export function Admin() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState<Tab>('verksamheter');
  const {
    requests
  } = useContent();
  const {
    partners
  } = usePlatform();
  if (!isLoggedIn) {
    return <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6 py-20" data-id="element-771" data-mp="3fprwdw2yj281">
        <div className="w-full max-w-md rounded-3xl bg-white p-10 shadow-floating" data-id="element-772" data-mp="3bmc050usv3vv">
          <div className="mb-8 flex justify-center" data-id="element-773" data-mp="36ojyhf4cs3eh">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-black text-white" data-id="element-774" data-mp="36nr29830swal">
              <LockIcon className="h-6 w-6" data-id="element-775" data-mp="31r0jue3qtom0" />
            </div>
          </div>
          <h1 className="text-center font-display text-3xl font-medium text-gray-900" data-id="element-776" data-mp="2wwo002ycub9q">Logga in</h1>
          <p className="mt-2 text-center text-sm text-gray-500" data-id="element-777" data-mp="2rznrzmhy2yfz">Adminportal för Smaken som Baken</p>

          <form className="mt-8 space-y-5" onSubmit={e => {
          e.preventDefault();
          setIsLoggedIn(true);
        }} data-id="element-778" data-mp="2nz3xyrso4ay2">
            <div data-id="element-779" data-mp="2ixoa6rz3vqbz">
              <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-780" data-mp="2j0aiitttm9v9">E-postadress</label>
              <input type="email" required placeholder="admin@smakensombaken.se" className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-781" data-mp="24c0mwxxlw5ow" />
            </div>
            <div data-id="element-782" data-mp="1zc4ln6gamsd1">
              <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-783" data-mp="1zdpdgob83x77">Lösenord</label>
              <input type="password" required placeholder="••••••••" className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-784" data-mp="2n2qtawmdyami" />
            </div>
            <button type="submit" className="mt-2 w-full rounded-full bg-black py-4 text-sm font-medium text-white transition-transform hover:scale-[1.02]" data-id="element-785" data-mp="2ia7clqseizdh">
              Logga in
            </button>
          </form>
        </div>
      </div>;
  }
  const newRequests = requests.filter(r => r.status === 'ny').length;
  const totalProducts = partners.reduce((sum, p) => sum + p.items.length, 0);
  return <div className="flex min-h-screen bg-gray-50" data-id="element-786" data-mp="192dv85wbhmig">
      <aside className="sticky top-28 hidden h-[calc(100vh-7rem)] w-56 shrink-0 flex-col border-r border-gray-100 bg-white p-6 lg:flex" data-id="element-787" data-mp="192476nuu1pfe">
        <p className="text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-788" data-mp="gdym1zzv9yf1">Adminportal</p>

        <nav className="mt-8 space-y-1" data-id="element-789" data-mp="beveo8wezg3w">
          {TABS.map(({
          id,
          label,
          icon: Icon
        }) => <button key={id} onClick={() => setActiveTab(id)} className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${activeTab === id ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-790" data-mp="peobmlyjaskb">
              <Icon className="h-4 w-4" data-id="element-791" data-mp="1wszvvc3zs4if" />
              {label}
              {id === 'forfragningar' && newRequests > 0 && <span className="ml-auto flex h-5 min-w-[20px] items-center justify-center rounded-full bg-gray-900 px-1.5 text-[10px] font-bold text-white" data-id="element-792" data-mp="2s3zcxvyfhlsf">
                  {newRequests}
                </span>}
            </button>)}
        </nav>

        <div className="mt-8 rounded-2xl bg-gray-50 p-4 text-xs text-gray-500" data-id="element-793" data-mp="3637das6buzy7">
          <p data-id="element-794" data-mp="3b1sh11ksg1re">{partners.length} verksamheter</p>
          <p className="mt-1" data-id="element-795" data-mp="3b10jhl7mrtyh">{totalProducts} produkter</p>
        </div>

        <div className="mt-auto space-y-2 pt-6" data-id="element-796" data-mp="3f1sv2l3z6axx">
          <Link to="/" className="flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100" data-id="element-797" data-mp="3f0hqij2pgz5r">
            <ExternalLinkIcon className="h-4 w-4" data-id="element-798" data-mp="3ourr2o1sx3rk" /> Visa sajten
          </Link>
          <button onClick={() => setIsLoggedIn(false)} className="flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100" data-id="element-799" data-mp="3ttbe6rs4slli">
            <LogOutIcon className="h-4 w-4" data-id="element-800" data-mp="1n157ovs8wgat" /> Logga ut
          </button>
        </div>
      </aside>

      <main className="min-w-0 flex-1 p-6 md:p-10" data-id="element-801" data-mp="1i6ren0122l9b">
        {/* Mobile tabs */}
        <div className="mb-8 flex gap-2 overflow-x-auto lg:hidden" data-id="element-802" data-mp="1d7ejls0167vn">
          {TABS.map(({
          id,
          label
        }) => <button key={id} onClick={() => setActiveTab(id)} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${activeTab === id ? 'bg-black text-white' : 'bg-white text-gray-600'}`} data-id="element-803" data-mp="188lfurajpv8o">
              {label}
            </button>)}
        </div>

        {activeTab === 'verksamheter' && <PartnerWorkspace data-id="element-804" data-mp="2ok78mv1fsi80" />}
        {activeTab === 'startsida' && <ContentManager data-id="element-805" data-mp="2ols3klrny36e" />}
        {activeTab === 'forfragningar' && <RequestManager data-id="element-806" data-mp="2jtih5fprbl8v" />}
      </main>
    </div>;
}